import DateFnsUtils from '@date-io/date-fns';
import theme from '@ifca-root/react-component/src/assets/theme';
import CardContents from '@ifca-root/react-component/src/components/CardList/CardContents';
import EmptyList from '@ifca-root/react-component/src/components/CardList/EmptyList';
import { MultiPieChart } from '@ifca-root/react-component/src/components/Charts/MultiPieChart';
import { DynamicFooter } from 'components/Footer/DynamicFooter';
import DynamicSubHeader from '@ifca-root/react-component/src/components/Header/DynamicSubHeader';
import MainHeader from '@ifca-root/react-component/src/components/Header/MainHeader';
import { ContentWrapper } from '@ifca-root/react-component/src/components/Layout/ContentWrapper';
import {
	StyledMenu,
	StyledMenuItem,
} from '@ifca-root/react-component/src/components/others/Menu';
import { CardActions, ListItemText, useMediaQuery } from '@material-ui/core';
import ShareIcon from '@material-ui/icons/Share';
import {
	KeyboardDatePicker,
	MuiPickersUtilsProvider,
} from '@material-ui/pickers';
import AppContext from 'containers/App/Store/AppContext';
import {
	useCreateReceiptAttachmentMutation,
	useEmailSendMutation,
	useGetOutletQuery,
	useGetPatronTypeAnalysisLazyQuery,
	useGetShareAttachmentMutation,
} from 'generated/graphql';
import { formatDate } from 'helpers/hooks/formatDate';
import { useMenuOption } from 'helpers/hooks/useMenuOption';
import * as htmlToImage from 'html-to-image';
import React, { useContext, useEffect, useRef, useState } from 'react';
import { useHistory } from 'react-router-dom';
import ShareDialog, { EmailDialog, PhoneNumDialog } from '../../../../../components/Dialog/ShareDialog';
import { useSnackBar } from 'helpers/hooks/useSnackBar';
import SnackBarMsg from '@ifca-root/react-component/src/components/SnackBar/SnackBarMsg';
import ReactDOMServer from 'react-dom/server';

const data = [
	{ name: 'Balance To Spend', value: 400 },
	{ name: 'Subcontract Cost', value: 300 },
	{ name: 'Material Cost', value: 300 },
	{ name: 'P&M Cost', value: 200 },
	{ name: 'Labour Cost', value: 200 },
	{ name: 'Misc. Expenses', value: 200 },
];

const COLORS = ['#0a3d62', '#0d71a5', '#34bcd2', '#ffc853', '#f8f0d7'];

export const PatronTypeAnalysis = (props: any) => {
	const history = useHistory();
	const user = JSON.parse(localStorage.getItem('loggedInUser'));
	const latestOutlet = localStorage.getItem('latestOutlet');

	const { globalState } = useContext(AppContext as any);
	const isDesktop = useMediaQuery(theme.breakpoints.up('sm'), {
		defaultMatches: true,
	});

	const { anchorEl, menu, handleClick, handleClose } = useMenuOption();
	const [selectedOutlet, setSelectedOutlet] = useState(null);

	const date = new Date();
	const firstDay = new Date(date.getFullYear(), date.getMonth(), 1);
	const lastDay = new Date(date.getFullYear(), date.getMonth() + 1, 0);

	//selectedStartDate
	const [selectedStartDate, setSelectedStartDate] = React.useState<Date | null>(
		firstDay,
	);
	const handleStartDateChange = (date: Date | null) => {
		setSelectedStartDate(date);
	};

	//selectedEndDate
	const [selectedEndDate, setSelectedEndDate] = React.useState<Date | null>(
		lastDay,
	);
	const handleEndDateChange = (date: Date | null) => {
		setSelectedEndDate(date);
	};

	const {
		data: { getOutlet } = { getOutlet: [] },
		called: getOutletCalled,
		loading: getOutletLoading,
	} = useGetOutletQuery({
		fetchPolicy: 'network-only',
	});

	useEffect(() => {
		setSelectedOutlet(
			getOutlet?.filter(outlet => outlet?.ID === latestOutlet)[0],
		);
	}, [getOutlet]);

	const [
		loadPatronTypeAnalysis,
		{
			data: { patronTypeAnalysis } = { patronTypeAnalysis: [] },
			called: patronTypeAnalysisCalled,
			loading: patronTypeAnalysisLoading,
		},
	] = useGetPatronTypeAnalysisLazyQuery({
		fetchPolicy: 'network-only',
	});

	useEffect(() => {
		if (selectedOutlet && selectedStartDate && selectedEndDate) {
			loadPatronTypeAnalysis({
				variables: {
					outletID: selectedOutlet?.ID,
					startDate: selectedStartDate,
					endDate: selectedEndDate,
				},
			});
		}
	}, [selectedOutlet, selectedStartDate, selectedEndDate]);

	const [openShareDialog, setOpenShareDialog] = useState(false);
	const [openSendEmail, setOpenSendEmail] = useState(false);
	const [openPhoneNum, setOpenPhoneNum] = useState(false);
	const [email, setEmail] = useState('');
	const [openEmail, setOpenEmail] = useState(false);
	const [phoneNumber, setPhoneNumber] = useState('');
	const { snackFunc, snackBarMessage, openSnackBar } = useSnackBar();
	const [
		getShareAttachment,
		{
			data: { shareAttachment } = { shareAttachment: {} as any },
			called: shareAttachmentCalled,
			loading: shareAttachmentLoading,
		},
	] = useGetShareAttachmentMutation({
		onCompleted: () => {
			setOpenShareDialog(true);
		},
	});

					const [ 
						createAttachment,
						{
							data: {  } = {
								createReceiptAttachment: {} as any,
							},
							called: createReceiptAttachmentCalled,
							loading: createReceiptAttachmentLoading,
						},
					] = useCreateReceiptAttachmentMutation({});
		
				const [
							EmailSend,
							{
								data: { emailSend } = { emailSend: {} as any },
								loading: loadingEmailSend,
							},
						] = useEmailSendMutation({});
		
								const ContentShare = () => (
						<div
							className="content-container"
							style={{
								position: 'fixed',
								top: '50%',
								left: '50%',
								transform: 'translate(-50%, -50%)',
							}}
						>
							<a target="_blank" rel="noopener noreferrer">
								<img
									src={shareAttachment?.fileURL}
									alt="Displayed Image"
									width="500px"
									height="500px"
								/>
							</a>
						</div>
					);
				
					const body = `Dear Customer,
				
				
				Please find the attached Patron Type Analysis. The details as follows:
				
				Outlet Name: ${selectedOutlet?.name}
				`;
				
					useEffect(() => {
						const QRContentString = ReactDOMServer.renderToStaticMarkup(ContentShare());
				
						openSendEmail &&
							EmailSend({
								variables: {
									body: {
										Header: `${selectedOutlet?.name} has shared you a file `,
										Body: body,
									},
									outletID: selectedOutlet?.ID,
									email:email,
									attachments: {
										filename: `Patron Type Analysis - ${selectedOutlet?.name}.jpg`,
										path: shareAttachment?.fileURL,
										cid: QRContentString,
									},
								},
							}).then(x => {
								if (x?.data?.emailSend === true) {
									snackFunc('Sent Email Successfully!', false);
									setOpenShareDialog(false);
								} else {
									snackFunc('Sent Email Fail!', false);
								}
							});
					}, [openSendEmail]);
				
						const shareReceiptRef = document.getElementById('PATRON-TYPE');
							console.log('shareReceiptRef',shareReceiptRef);
							
							useEffect(() => {
								if (openShareDialog) {
									const timeoutId = setTimeout(() => {
										if (shareReceiptRef) {
											const attachment = shareReceiptRef;
											console.log('attachment',attachment);
											
											htmlToImage
												.toBlob(attachment, {
													style: { background: '#ffffff' },
													cacheBust: true,
												})
												.then(value => {
													console.log('value',value);
													
													onSubmit(value);
												})
												.catch(error => {
													console.error('Error generating image blob:', error);
												});
										} else {
											console.error('Element with id "share-receipt" not found.');
										}
									}, 1000); // Delay execution to allow for rendering
						
									return () => clearTimeout(timeoutId); // Cleanup timeout on unmount
								}
							}, [openShareDialog]);

	const onSubmit = blob => {
		getShareAttachment({
			variables: {
				file: blob,
				outletID: selectedOutlet?.ID,
			},
		});
	};
	// useEffect(() => {
	// 	if (openShareDialog) {
	// 		getShareBlob();
	// 	}
	// }, [openShareDialog, getPatronTypeAnalysis]);

	// const getShareBlob = async () => {
	// 	let temp = document.getElementById('pieChart');
	// 	htmlToImage
	// 		.toBlob(temp, { style: { background: '#fff' } })
	// 		.then((value) => {
	// 			onSubmit(value);
	// 		});
	// };

	return (
		<>
			<MainHeader
				onClick={() =>
					history.push({
						pathname: `/menu/outlet-app/business-insight/business-analytic`,
					})
				}
				mainBtn="back"
				smTitle="Business Insights"
				// HC
				title={user?.companyName}
				routeSegments={[
					{ name: 'Business Insights' },
					{ name: 'Patron Type Analysis', current: true },
				]}
			/>

			{!getOutletLoading && (
				<DynamicSubHeader
					// style={{
					// 	width:
					// 		isDesktop && globalState.drawerOpen
					// 			? 'calc(100% - 288px)'
					// 			: isDesktop && !globalState.drawerOpen
					// 			? `calc(100% - 48px)`
					// 			: null,
					// }}
					title={
						getOutlet === undefined || getOutlet?.length === 0
							? ``
							: `${selectedOutlet?.name}`
					} // title text
					handleClick={e => handleClick(e, null, 0)} // onClick function for dropdown
					dropDownOptions={
						// dropdown component place here
						<StyledMenu
							id="customized-menu"
							anchorEl={anchorEl}
							keepMounted
							open={Boolean(anchorEl)}
							onClose={handleClose}
							onClick={handleClose}
						>
							{getOutlet.map((outlet, index) => (
								<StyledMenuItem
									key={index}
									value={outlet.ID}
									defaultValue={outlet.ID}
									onClick={e => {
										setSelectedOutlet(outlet);
									}}
								>
									<ListItemText primary={outlet?.name} />
								</StyledMenuItem>
							))}
						</StyledMenu>
					}
				/>
			)}
			<ContentWrapper search footer>
				<div id='PATRON-TYPE'>
				<CardActions style={{ paddingTop: '0px' }}>
					<MuiPickersUtilsProvider utils={DateFnsUtils}>
						<KeyboardDatePicker
							id="date-picker-dialog"
							style={{
								background: 'white',
								width: '50%',
								zIndex: 40,
							}}
							format="dd MMM yyyy"
							value={selectedStartDate}
							onChange={handleStartDateChange}
							KeyboardButtonProps={{
								'aria-label': 'change date',
							}}
							inputVariant="outlined"
							size="small"
							className="left"
						/>

						<KeyboardDatePicker
							id="date-picker-dialog"
							format="dd MMM yyyy"
							value={selectedEndDate}
							style={{
								background: 'white',
								width: '50%',
								zIndex: 40,
							}}
							onChange={handleEndDateChange}
							KeyboardButtonProps={{
								'aria-label': 'change date',
							}}
							inputVariant="outlined"
							size="small"
							className="right"
						/>
					</MuiPickersUtilsProvider>
				</CardActions>
				{!patronTypeAnalysisLoading &&
				!getOutletLoading &&
				(patronTypeAnalysis === undefined ||
					patronTypeAnalysis?.length === 0) ? (
					<EmptyList
						title={`No order created for ${selectedOutlet?.name} within the date range`}
						subtitle="Please create a new order to continue"
					/>
				) : (
					!getOutletLoading &&
					!patronTypeAnalysisLoading && (
						<>
							{patronTypePieChart(patronTypeAnalysis, selectedOutlet)}
							{patronTypePieChart(
								patronTypeAnalysis,
								selectedOutlet,
								selectedStartDate,
								selectedEndDate,
								formatDate,
								true,
							)}
							<div className="cover-layer">
								<CardContents>
									<></>
								</CardContents>
							</div>
						</>
					)
				)}
				</div>
			</ContentWrapper>

			{ShareDialog({
				shareTitle: `Patron Type Analysis - ${selectedOutlet?.name}`,
				title: `Share`,
				URL: shareAttachment?.fileURL,
				setSimple: setOpenShareDialog,
				simple: openShareDialog,
				emailShare:email,
				setSimpleEmail: setOpenSendEmail,
				isReceipt: true,
				phoneNumber: phoneNumber,
				setOpenPhoneNum: setOpenPhoneNum,
				setOpenEmail: setOpenEmail,
			})}

			<PhoneNumDialog
				open={openPhoneNum}
				setOpen={setOpenPhoneNum}
				shareTitle={`Patron Type Analysis - ${selectedOutlet?.name}`}
				URL={shareAttachment?.fileURL}
			/>

			<EmailDialog
				open={openEmail}
				setOpen={setOpenEmail}
				setSimpleEmail={setOpenSendEmail}
				setEmail={setEmail}
			/>
			<DynamicFooter
				overlap
				options={[
					// {
					// 	name: 'Share',
					// 	onClick: async () => {
					// 		let temp = await document.getElementById('hiddenPieChart');
					// 		htmlToImage
					// 			.toBlob(temp, { style: { background: '#fff' } })
					// 			.then(value => {
					// 				onSubmit(value);
					// 			});
					// 	},
					// 	disabled:
					// 		patronTypeAnalysis == undefined || patronTypeAnalysis.length == 0,
					// 	color: 'primary',
					// 	props: {
					// 		type: 'submit',
					// 	},
					// 	startIcon: <ShareIcon style={{ fontSize: '18px' }} />,
					// },
					{
						name: 'Share',
							onClick: () => {
								setOpenShareDialog(true);
							},
						disabled:
									patronTypeAnalysis == undefined || patronTypeAnalysis.length == 0,
						color: patronTypeAnalysis == undefined || patronTypeAnalysis.length == 0 ? 'inherit' : 'primary',
						props: {
								type: 'submit',
							},
							startIcon: <ShareIcon style={{ fontSize: '18px' }} />,
					},
				]}
			/>
						<SnackBarMsg open={openSnackBar} message={snackBarMessage} />
		</>
	);
};

const heightConst = 400;
const patronTypePieChart = (
	patronTypeAnalysis,
	selectedOutlet,
	selectedStartDate?: any,
	selectedEndDate?: any,
	formatDate?: any,
	hidden?: boolean,
) => {
	return (
		<div
			style={
				hidden
					? {
							zIndex: -40,
							top: 0,
							left: 0,
							position: 'fixed',
							width: '100%',
					  }
					: {
							marginTop: '0px',
							zIndex: 40,
							position: 'relative',
					  }
			}
			className={hidden ? 'hidden-content' : null}
		>
			<CardContents
				section={
					!hidden
						? {
								header: {
									title: 'Customer Type',
								},
						  }
						: null
				}
			>
				<div
					style={{
						width: '100%',
						height: !hidden ? heightConst : heightConst + 44,
					}}
					id={!hidden ? 'pieChart' : 'hiddenPieChart'}
				>
					<MultiPieChart
						data={patronTypeAnalysis}
						outlet={hidden ? selectedOutlet : null}
						analysis={hidden ? 'Patron Type' : null}
						selectedStartDate={hidden ? selectedStartDate : null}
						selectedEndDate={hidden ? selectedEndDate : null}
						formatDate={formatDate}
					/>
				</div>
			</CardContents>
		</div>
	);
};
